(function () {
  function safeEqual(left, right) {
    if (typeof left !== 'string' || typeof right !== 'string' || left.length !== right.length) {
      return false;
    }

    var mismatch = 0;
    for (var index = 0; index < left.length; index += 1) {
      mismatch |= left.charCodeAt(index) ^ right.charCodeAt(index);
    }

    return mismatch === 0;
  }

  function toHex(buffer) {
    return Array.from(new Uint8Array(buffer))
      .map(function (byte) {
        return byte.toString(16).padStart(2, '0');
      })
      .join('');
  }

  function hmacSha256Hex(message, secret) {
    var encoder = new TextEncoder();

    return crypto.subtle
      .importKey('raw', encoder.encode(secret), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign'])
      .then(function (key) {
        return crypto.subtle.sign('HMAC', key, encoder.encode(message));
      })
      .then(function (signature) {
        return toHex(signature);
      });
  }

  function readStored(storageKey) {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey));
    } catch (error) {
      return null;
    }
  }

  function isValidAccess(stored, config) {
    if (!stored) {
      return false;
    }

    if (!safeEqual(String(stored.digest || ''), String(config.digest || ''))) {
      return false;
    }

    if (Number(stored.expirationDays) !== Number(config.expirationDays)) {
      return false;
    }

    return Date.now() < Number(stored.expiresAt);
  }

  function lockPage() {
    document.documentElement.classList.add('collection-pw-protected');
    document.documentElement.classList.remove('collection-pw-unlocked');
  }

  function unlockPage() {
    document.documentElement.classList.remove('collection-pw-protected');
    document.documentElement.classList.add('collection-pw-unlocked');
  }

  function expirationDaysFrom(config) {
    var days = parseInt(config.expirationDays, 10);
    if (isNaN(days) || days < 1) {
      return 20;
    }
    return days;
  }

  function initForm(config) {
    var root = document.querySelector('[data-collection-password-protection]');
    if (!root) {
      return;
    }

    var form = root.querySelector('[data-collection-password-form]');
    var errorEl = root.querySelector('[data-collection-password-error]');
    var input = root.querySelector('[data-collection-password-input]');
    if (!form || !input) {
      return;
    }

    input.addEventListener('input', function () {
      input.classList.toggle('is-filled', input.value.length > 0);
      input.removeAttribute('aria-invalid');
      if (errorEl) {
        errorEl.hidden = true;
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
      }

      hmacSha256Hex(input.value || '', config.salt)
        .then(function (digest) {
          if (!safeEqual(digest, config.digest)) {
            if (errorEl) {
              errorEl.hidden = false;
            }
            input.setAttribute('aria-invalid', 'true');
            input.focus();
            return;
          }

          var expirationDays = expirationDaysFrom(config);
          var payload = {
            digest: config.digest,
            expirationDays: expirationDays,
            expiresAt: Date.now() + expirationDays * 24 * 60 * 60 * 1000
          };

          try {
            window.localStorage.setItem(config.storageKey, JSON.stringify(payload));
          } catch (error) {
            // Session unlock still applies when storage is unavailable.
          }

          unlockPage();
        })
        .catch(function () {
          if (errorEl) {
            errorEl.hidden = false;
          }
        })
        .then(function () {
          if (submitButton) {
            submitButton.disabled = false;
          }
        });
    });
  }

  function syncAccess(config) {
    var stored = readStored(config.storageKey);

    if (isValidAccess(stored, config)) {
      unlockPage();
      return;
    }

    lockPage();

    if (stored) {
      try {
        window.localStorage.removeItem(config.storageKey);
      } catch (error) {
        // Ignore storage errors.
      }
    }
  }

  function boot() {
    var config = window.HBCollectionPassword;
    if (!config || !config.digest || !config.salt || !config.storageKey) {
      return;
    }

    syncAccess(config);
    initForm(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
